import { render } from "./MainScreen.vue?vue&type=template&id=7baf0a4e"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import "./MainScreen.vue?vue&type=style&index=0&id=7baf0a4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__